import { Injectable } from '@angular/core';
import { environment } from '@env/environment.prod';
import CryptoJS from 'crypto-js';
import SecureStorage from 'secure-web-storage';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    constructor() { }
    public secureStorage = new SecureStorage(localStorage, {
        hash: function hash(key): any {
            key = CryptoJS.SHA256(key, environment.prefix);
            return key.toString();
        },
        // Encrypt the localstorage data
        encrypt: function encrypt(data) {
            data = CryptoJS.AES.encrypt(data, environment.prefix);
            data = data.toString();
            return data;
        },
        // Decrypt the encrypted data
        decrypt: function decrypt(data) {
            data = CryptoJS.AES.decrypt(data, environment.prefix);
            data = data.toString(CryptoJS.enc.Utf8);
            return data;
        }
    });
}